import React, { CSSProperties } from 'react';
import { ReadOnlyIdView, ButtonView, ReadOnlyTextView, ReadOnlyNumberView } from '@vivli/shared/views';
import { cardContainerStyle, upperSectionStyle } from './card-styles';
import { IEnquiryActionDetailDto } from '@vivli/features/dashboard/infrastructure/interface';
import { Size } from '@vivli/shared/theme';

interface EnquiryActionCardViewProps {
    dto: IEnquiryActionDetailDto;
    isVivliAdmin?: boolean;
    studiesLabel?: string;
}

const upperSection5ColsStyle: CSSProperties = {
    ...upperSectionStyle,
    gridTemplateColumns: '160px 1fr 1fr 1fr auto',
    paddingRight: Size.PADDING * 1.5,
};

const oneRowSmallComponentStyle: CSSProperties = {
    paddingBottom: Size.PADDING,
};

export const EnquiryActionCardView = ({ dto, isVivliAdmin, studiesLabel }: EnquiryActionCardViewProps) => {
    const studiesContent = isVivliAdmin ? dto.numberOfStudies : dto.numberOfMyStudies;

    const handleEnquiryActionDestination = () => {
        const destination = `admin/enquiry/${dto.uniqueId}`;
        window.open(destination, '_blank');
    };

    return (
        <div style={cardContainerStyle}>
            <div style={upperSection5ColsStyle}>
                <div style={{ paddingBottom: Size.PADDING }}>
                    <ReadOnlyIdView idContent={dto.vivliId} idHeader={'Enquiry ID'}></ReadOnlyIdView>
                </div>
                <div style={oneRowSmallComponentStyle}>
                    <ReadOnlyNumberView
                        numberContent={studiesContent}
                        numberHeader={studiesLabel}
                        useWarningColors={false}
                    ></ReadOnlyNumberView>
                </div>
                <div style={oneRowSmallComponentStyle}>
                    <ReadOnlyNumberView
                        numberContent={dto.daysLeft}
                        numberHeader={'Days In Current Step'}
                        useWarningColors={true}
                        warningOn={dto.daysWarning}
                    ></ReadOnlyNumberView>
                </div>
                <div style={oneRowSmallComponentStyle}>
                    <ReadOnlyTextView textContent={dto.requester} textHeader={'Requested By'}></ReadOnlyTextView>
                </div>
                <div style={{ justifySelf: 'end', paddingBottom: Size.PADDING }}>
                    <ButtonView title={dto.actionText} theme={'white-on-lightblue'} onClick={handleEnquiryActionDestination}>
                        {dto.actionText}
                    </ButtonView>
                </div>
            </div>
        </div>
    );
};
